import React, { useEffect, useRef } from "react";
import L from "leaflet";
import Moment from "moment";

const style = {
  height: "75vh"
};

export const issMarkerIcon = new L.Icon({
  iconUrl: require("../../../assets/images/space-station.png"),
  iconRetinaUrl: require("../../../assets/images/space-station.png"),
  iconAnchor: [20, 40],
  popupAnchor: [0, -35],
  iconSize: [40, 40]
});

const OpenMapContainer = props => {
  const { markerPosition } = props;

  const mapRef = useRef(null);
  useEffect(() => {
    mapRef.current = L.map("map", {
      center: [-25.75, 28.33],
      zoom: 2,
      style: { height: "75vh" },
      
      layers: [
        L.tileLayer(
          "https://map1.vis.earthdata.nasa.gov/wmts-webmerc/VIIRS_CityLights_2012/default/{time}/{tilematrixset}{maxZoom}/{z}/{y}/{x}.{format}",
          {
            attribution:
              'Imagery provided by services from the Global Imagery Browse Services (GIBS), operated by the NASA/GSFC/Earth Science Data and Information System (<a href="https://earthdata.nasa.gov">ESDIS</a>) with funding provided by NASA/HQ.',
            bounds: [
              [-85.0511287776, -179.999999975],
              [85.0511287776, 179.999999975]
            ],
            minZoom: 1,
            maxZoom: 8,
            format: "jpg",
            time: "",
            tilematrixset: "GoogleMapsCompatible_Level"
          }
        )
      ]
    });

    // map the user locations, should only happen when map initializes
    if (props.userActivityPositions) {
      props.userActivityPositions.map(element => {
        const label =
          Moment(element.date.seconds * 1000).format("YYYY/MM/DD HH:mm") +
          " " +
          (element.application ? element.application : "Angular");
        L.marker([element.latitude, element.longitude])
          .addTo(mapRef.current)
          .bindPopup(label);
      });
    }
  }, []);

  // add iss marker ref
  const issMarkerRef = useRef(null);
  useEffect(() => {
    if (issMarkerRef.current) {
      issMarkerRef.current.setLatLng(markerPosition);
    } else {
      issMarkerRef.current = L.marker(markerPosition)
        .addTo(mapRef.current)
        .setIcon(issMarkerIcon)
        .bindPopup("International Space Station");
    }
  }, [markerPosition]);

  return <div id="map" style={style} />;
};

export default OpenMapContainer;
